// The new admin SPA reads Vite env and exposes the backend origin + the stub
// employee identity. All /api/admin/* + /api/admin/permissions/* traffic goes
// through the single typed client (src/lib/api.ts); this file only needs the base
// URL and the identity header value.
import { effectiveEmployeeEmail } from "./lib/identity";

const env = import.meta.env;

// The employee email the SPA presents. In cloud the real email is the Google
// `admin_authority` cookie email (the SPA can't read the HttpOnly cookie); it's
// fetched once via GET /api/admin/me at boot and cached (see lib/api.ts →
// lib/identity.ts). Locally the stub default flows through the `X-Employee-Email`
// header, which the backend's stub-mode auth honors. Empty string while SIGNED
// OUT so `effectiveEmployeeEmail` suppresses the header and log out actually
// ends the session.
export const EMPLOYEE_EMAIL =
  effectiveEmployeeEmail(env.VITE_DEV_EMPLOYEE_EMAIL ?? "employee@fiverr.com") ?? "";

// Absolute backend origin. Same service as the client API in local dev (gated by
// employee scope); the same-origin admin host in cloud (the LB routes /api/* to
// the backend), so the base is that origin and the cookie rides same-origin.
export const ADMIN_API_BASE = env.VITE_API_BASE_URL ?? "http://localhost:8200";

// True ONLY in the real production build: the prod deploy workflow injects
// VITE_APP_ENV="prod" (deploy-admin-prod.yml); unset everywhere else (local,
// dev, preview, preprod). Unlike `import.meta.env.PROD` (true for EVERY deployed
// bundle), this singles out real production. Used to withhold the tester Debug
// toggle there, matching the buyer SPA (frontend/web config.ts IS_PROD) and the
// server-side gate (POST /api/admin/debug-notes 404s in prod).
export const IS_PROD = env.VITE_APP_ENV === "prod";
